<template>
    <div>
        <div class="moderation page-container">
        <PageContent :content="content" img-bg-size="70%">
            <p style="font-weight: bold">NEW PERFORMANCE - NEW LEADERSHIP - NEW WORK</p>
        </PageContent>
        </div>
        <div class="arrow-container">
            <a href="#prisma" v-smooth-scroll>
                <img src="../assets/icons/arrow_down.png" @click="scrollDown">
            </a>
        </div>
        <div class="prisma-container" id="prisma">
            <div class="prisma">
                <img src="../assets/prisma_diagramm.png">
            </div>
            <p>Neue Seminar-Reihen der Dr. Thumm GmbH</p>
            <div class="button-container">
                <div @click="openPDF('new_leadership')">NEW LEADERSHIP</div>
                <div @click="openPDF('new_work')">NEW WORK</div>
                <div @click="openPDF('new_performance')">NEW PERFORMANCE</div>
            </div>
        </div>
    </div>
</template>
<script>
    import newThinking from '../content/new-thinking.json'
    import PageContent from "../components/PageContent";


    export default {
        components: {PageContent},
        metaInfo() {
            return {
                title: this.page.title,
                titleTemplate: "%s | DrThumm GmbH",
                meta: [
                    { name: 'description', content: this.page.metaDescription }
                ]
            }
        },
        data() {
            return {
                content: {
                    'new-thinking': newThinking
                }
            }
        },
        computed: {
            page() {
                this.showImage = false
                let route = this.$route.fullPath
                let routes = route.split('/')
                var filtered = routes.filter(el => el != "" )
                let content = this.content
                console.log(content.prisma)
                filtered.forEach(r => {
                    if (filtered.length === 1) content = content[r][r]
                    else content = content[r]
                })
                return content
            }

        },
        methods: {
            openPDF(key) {
                switch (key) {
                    case "new_work":
                        window.open('https://dr-thumm.de/static/files/prisma_STRATEGIE_new_work.pdf')
                        break

                    case "new_leadership":
                        window.open('https://dr-thumm.de/static/files/prisma_STRATEGIE_new_leadership.pdf')
                        break

                    case "new_performance":
                        window.open('https://dr-thumm.de/static/files/prisma_STRATEGIE_new_performance.pdf')
                        break
                }

            },
            scrollDown() {

            }
        },
        updated() {
            this.showImage = true
        },
        beforeCreate() {
            document.body.className = ""
        }
    }
</script>
<style lang="sass" scoped>

    .page-container.row
        flex-direction: column

    .arrow-container
        text-align: center
        position: relative
        top: -200px
        cursor: pointer


    .prisma-container

        p
            text-align: center

        .button-container
            display: flex
            justify-content: center
            margin-bottom: 100px

            > div

                &:hover
                    text-decoration: underline
                    text-decoration-color: #000

                cursor: pointer
                padding: 10px
                font-size: 27px
                margin-right: 10px
                color: #8b634b

                &:last-child
                    margin-right: 0


        .prisma
            background-color: #8b634b
            width: 100vw
            text-align: center

    @media (max-width: 1300px)
        .prisma
            img
                width: 80%

    @media (max-width: 900px)
        .arrow-container
            top: -20px


    @media (max-width: 600px)
        .prisma-container
            .button-container
                flex-direction: column
                align-items: center
                > div
                    width: 80%
                    text-align: center
                    margin-bottom: 20px


</style>